export const handleConvertNumberUtil = (time?: string): number => {
  if (!time) {
    return 0;
  }

  const parts = time.split(':').map(Number);

  if (parts.length === 2 && !Number.isNaN(parts[0]) && !Number.isNaN(parts[1])) {
    const [min, sec] = parts;

    return Math.max(0, Math.floor(min) * 60 + Math.floor(sec));
  }

  return 0;
};
